import React, { useState } from "react";
import PropTypes from "prop-types";

import { useSelector } from "react-redux";
import { AGREEMENT, PRIVATE_DATA_POLICY, ADS, OFFER_DEFAULT } from "../utils/consts/index.js";

import UModal from "../components/Modals/UModal.jsx";
import WrapperContainer from "../components/WrapperContainer/WrapperContainer.jsx";

import Checkbox from "../components/Checkbox/Checkbox.jsx";
import Input from "../components/Input/Input.jsx";

import Button from "../components/Button/Button.jsx";
import { useFormFeedback } from "../hooks/useFormFeedback.js";

import handleNotify from "../utils/helpers/handleNotify.js";
import checkPhoneNumberLength from "../utils/helpers/checkPhoneNumberLength.js";

const ModalFormFeedback = ({ isOpenModal, closeModal }) => {
  const { mobileConnectionInfo } = useSelector(state => state);

  const [agreements, setAgreements] = useState({
    offerta: false,
    policy: false,
    ads: false,
  });

  // TODO: upgrade to RHF
  const [userName, setUserName] = useState("");
  const [userPhoneNumber, setUserPhoneNumber] = useState("");

  const [userAddress, setUserAddress] = useState("");
  const [userComment, setUserComment] = useState("");

  const { sendFormFeedback } = useFormFeedback();

  const sendDataFeedback = async () => {
    try {
      await sendFormFeedback(
        userName,
        userPhoneNumber,
        userAddress,
        mobileConnectionInfo.initialUrl,
        userComment
      );

      handleNotify(
        "success",
        null,
        "Заявка на обратный звонок отправлена. Ожидайте звонка оператора"
      );
      closeModal();
    } catch (error) {
      handleNotify("error", error);
    }
  };

  const isFillPhoneNumber = checkPhoneNumberLength(userPhoneNumber);
  const isFillRequiredFields =
    userName &&
    isFillPhoneNumber &&
    userAddress &&
    agreements.offerta &&
    agreements.policy;

  return (
    <UModal isOpenModal={isOpenModal} modalTitle="Адрес не найден" closeModal={closeModal}>
      <WrapperContainer gap="24" text="lg">
        Оставьте заявку, с Вами свяжется наш менеджер и проверит возможность подключения по адресу.
      </WrapperContainer>

      <form onSubmit={event => event.preventDefault()}>
        <WrapperContainer gap="16">
          <Input
            placeholder="ФИО"
            onChange={event => setUserName(event.target.value)}
            value={userName}
          />
        </WrapperContainer>

        <WrapperContainer gap="16">
          <Input
            type="tel"
            placeholder="Номер телефона"
            onChange={event => setUserPhoneNumber(event.target.value)}
            value={userPhoneNumber}
          />
        </WrapperContainer>

        <WrapperContainer gap="16">
          <Input
            placeholder="Адрес"
            onChange={event => setUserAddress(event.target.value)}
            value={userAddress}
          />
        </WrapperContainer>

        <WrapperContainer gap="16">
          <textarea
            className="textarea"
            placeholder="Комментарий"
            onChange={event => setUserComment(event.target.value)}
            value={userComment}
            rows={3}
          />
        </WrapperContainer>

        <WrapperContainer gap="24">
          <WrapperContainer gap="16">
            <Checkbox
              onChange={() =>
                setAgreements(prevState => ({
                  ...prevState,
                  offerta: !prevState.offerta,
                }))
              }
              checked={agreements.offerta}
            >
              <div>
                Я соглашаюсь с условиями{" "}
                <a className="link" href={OFFER_DEFAULT} target="_blank" rel="noreferrer">
                  оферты
                </a>
              </div>
            </Checkbox>
          </WrapperContainer>

          <WrapperContainer gap="16">
            <Checkbox
              onChange={() =>
                setAgreements(prevState => ({
                  ...prevState,
                  policy: !prevState.policy,
                }))
              }
              checked={agreements.policy}
            >
              <div>
                Я даю{" "}
                <a className="link" href={AGREEMENT} target="_blank" rel="noreferrer">
                  согласие на обработку моих персональных данных
                </a>{" "}
                в соответствии с{" "}
                <a className="link" href={PRIVATE_DATA_POLICY} target="_blank" rel="noreferrer">
                  политикой в отношении обработки персональных данных
                </a>
              </div>
            </Checkbox>
          </WrapperContainer>

          <WrapperContainer gap="16">
            <Checkbox
              onChange={() =>
                setAgreements(prevState => ({
                  ...prevState,
                  ads: !prevState.ads,
                }))
              }
              checked={agreements.ads}
            >
              <div>
                Я даю
                <a className="link" href={ADS} target="_blank" rel="noreferrer">
                  согласие на получение сообщений рекламно-информационного характера
                </a>
              </div>
            </Checkbox>
          </WrapperContainer>
        </WrapperContainer>

        <Button
          isSubmit
          isStretch
          color="primary"
          size="xl"
          onClick={sendDataFeedback}
          disabled={!isFillRequiredFields}
        >
          Оставить заявку
        </Button>
      </form>
    </UModal>
  );
};

ModalFormFeedback.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default ModalFormFeedback;
